export const GET_DISPLAY_MAINTENANCE_BANNER = 'GET_Displa_Maintenance_Banner'
export const HIDE_DISPLAY_MAINTENANCE_BANNER = 'HIDE_DISPLAY_MAINTENANCE_BANNER'



// WEBPACK FOOTER //
// ./src/actionTypes/Notifications/notification.js